// extracted by mini-css-extract-plugin
export default {"groteskBold":"CouponRedeemPage_groteskBold__uPWxY","uploadPhotoButton":"CouponRedeemPage_uploadPhotoButton__1dgwP"};